<template>
<!--  <button class="zui-button" @click="onClick">-->
<!--    <slot></slot>-->
<!--  </button>-->
  <el-carousel indicator-position="outside">
    <el-carousel-item v-for="(item,index) in items" :key="index">
      <div class="carousel-content">
        <el-row v-if="index!=2">
          <el-col :span="13">
            <img class="carousel-img" :src="item.img"/>
          </el-col>
          <el-col :span="11">
            <div class="common-img-wrapper">
              <div class="img-div">
              <img class="common-img" src="../../assets/img/home/carousel/c-1.jpg">
              <img class="common-img" src="../../assets/img/home/carousel/c-2.jpg">
              <img class="common-img" src="../../assets/img/home/carousel/c-3.jpg">
              <img class="common-img" src="../../assets/img/home/carousel/c-4.jpg">
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="12">
            <img class="carousel-img" :src="item.img" style="margin-left: 30px"/>
          </el-col>
          <el-col :span="12">
            <img class="carousel-img"  src="../../assets/img/home/carousel/4.jpg" style="margin-left: 50px"/>
          </el-col>
        </el-row>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  export default {
    data(){
      return{
        items:[
          {
            img:require("@/assets/img/home/carousel/1.jpg")
          },
          {
            img:require("@/assets/img/home/carousel/2.jpg")
          },
          {
            img:require("@/assets/img/home/carousel/3.jpg")
          }
        ]
      }
    },
    methods: {
      onClick (e) {
        this.$emit('click', e)
      }
    }
  }
</script>
<style lang="less">
  .el-carousel__container {
    height: 500px;
    .el-carousel__item {
      background-color:#fff;  //#f2f6f8;

      .carousel-content {
        padding: 30px;

        .carousel-img{
          height: 450px;
        }
        .common-img-wrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 400px;


          .img-div {


            .common-img {
              margin: 25px;
              width: 160px;
            }
          }
        }
      }
    }
  }
</style>
